import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';
import { GrupoProdutoService } from '../services/api/estoque/grupoProduto/GrupoProdutoService';

type TAutoCompleteOption = {
  idgrupo: string;
  label: string;
}

interface IAutoCompleteGrupoProps {
  isExternalLoading?: boolean;
  uuidgrupo?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteGrupoDeProdutos: React.FC<IAutoCompleteGrupoProps> = ({ isExternalLoading = false, uuidgrupo }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idgrupo');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
    if (selectedId !== null) {

      debounce(() => {
        GrupoProdutoService.getAlllist(busca, selectedId)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              // alert(result.message);
            } else {
              setOpcoes(result.data.map(grupo => ({ idgrupo: grupo.idgrupo, label: grupo.descricao })));
            }
          });
      });
    }setIsLoading(false);

  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idgrupo === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => { setSelectedId(newValue?.idgrupo); uuidgrupo?.(newValue?.idgrupo); setBusca(''); clearError(); }}
      popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Grupo"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};